import { IPPVCountryConfigResponse } from '../../../entity';
import { IUserRegistrationRepository } from '../../repositories/interfaces/iUserRegistrationRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IGetPPVCountryConfigUseCase {
    execute(country?: string): Promise<IPPVCountryConfigResponse['data']>;
}

export class GetPPVCountryConfigUseCase implements IGetPPVCountryConfigUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRegistrationRepo(): IUserRegistrationRepository {
        return container.resolve<IUserRegistrationRepository>(DI.REPOSITORIES.IUserRegistrationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(country?: string): Promise<IPPVCountryConfigResponse['data']> {
        const response = await this.userRegistrationRepo.getPPVCountryConfig(country);
        return response?.data;
    }
}
